import './styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ApiError } from './lib/api';
import { watchIdentityForOfflineWipe } from './lib/offline-wipe';
import { initTheme } from './lib/theme';
import { startUpdateWatch } from './lib/updates';
import { createAppRouter } from './router';

initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => !(err instanceof ApiError && err.status > 0 && err.status < 500) && count < 2,
    },
  },
});

const router = createAppRouter(queryClient);

// Сменились человек или компания во вкладке — запомненное для работы без связи прежним стирается (МП-13)
watchIdentityForOfflineWipe(queryClient);

// Предупреждения об обновлении портала (АД-09); когда связь вернулась — данные на странице обновляются
startUpdateWatch({ onRecovered: () => void queryClient.invalidateQueries() });

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}
